import { useMemo } from 'react';

import { useDebounce } from '@ais-ui/custom-hooks';
import { filterShapes, flattenShapes } from '../utils';
import { GeoJson } from '@ais-ui/api-spec/shapes';

export function filterAndFlattenShapes(
  shapes: GeoJson[],
  search = '',
  allowedGeometryTypes?: string[]
) {
  // First, filter the shapes
  const filteredShapes = filterShapes(
    shapes,
    search,
    allowedGeometryTypes
      ? allowedGeometryTypes
      : ['LineString', 'Polygon', 'Point', 'Circle']
  );

  // Then, flatten the filtered shapes
  return filteredShapes.flatMap((shape) => flattenShapes(shape));
}

export function useFilteredAndFlattenedShapes(
  shapes: GeoJson[],
  search: string,
  allowedGeometryTypes?: string[]
) {
  const bouncedSearch = useDebounce(search, 50);

  const flattenedShapes = useMemo(() => {
    return filterAndFlattenShapes(shapes, bouncedSearch, allowedGeometryTypes);
  }, [shapes, bouncedSearch, allowedGeometryTypes]);

  return flattenedShapes;
}
